import React from 'react';
import "./ModalBackdrop.scss";

function ModalBackdrop(props) {
    return (
        <div className='backdrop-container' />
    );
}

export default ModalBackdrop;